import joystickStyle from './joystick.module.css'
import joystickbg from '../../../../../../../Assets/humanoid/joystick.png'

import upBtn from '../../../../../../../Assets/humanoid/Up.png'
import upDarkBtn from '../../../../../../../Assets/humanoid/up_dark.png'
import downBtn from '../../../../../../../Assets/humanoid/down.png'
import downDarkBtn from '../../../../../../../Assets/humanoid/down_dark.png'
import leftBtn from '../../../../../../../Assets/humanoid/left.png'
import leftDarkBtn from '../../../../../../../Assets/humanoid/left_dark.png'
import rightBtn from '../../../../../../../Assets/humanoid/right.png'
import rightDarkBtn from '../../../../../../../Assets/humanoid/right_dark.png'
import midBtn from '../../../../../../../Assets/humanoid/mid.png'
import midDarkBtn from '../../../../../../../Assets/humanoid/mid.png'
import { useEffect, useState } from 'react'

const IMAGES = {
    upBtn,
    upDarkBtn,
    downBtn,
    downDarkBtn,
    leftBtn,
    leftDarkBtn,
    rightBtn,
    rightDarkBtn,
    midBtn,
    midDarkBtn,
}
const CONTROLS = ['up', 'down', 'left', 'right', 'mid']
const ACTIONS = {
    up: 'MoveForward',
    down: 'MoveBackward',
    left: 'MoveLeft',
    right: 'MoveRight',
    mid: 'AttentionMid',
}

const disabledJoyStick = {
    pointerEvents: 'None',
    opacity: '0.5',
}

const Joystick = ({
    actionState,
    isEnabled,
    setContinousAction,
    handleAction,
    handleContinuousAction,
    sendRa,
}) => {
    // const zingVersion = sessionStorage.getItem('zingVersion') || '0.0.0'
    // const deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'
    const [activeControl, setActiveControl] = useState(null)
    return (
        <div className={joystickStyle['joystick-image']}>
            {CONTROLS.map((control) => (
                <img
                    draggable={false}
                    key={control}
                    className={joystickStyle[`${control}-button`]}
                    style={
                        isEnabled
                            ? { touchAction: 'none' }
                            : { ...disabledJoyStick, touchAction: 'none' }
                    }
                    src={
                        actionState[`is${ACTIONS[control]}`]
                            ? IMAGES[`${control}DarkBtn`]
                            : IMAGES[`${control}Btn`]
                    }
                    onPointerDown={(e) => {
                        if (activeControl === control) return
                        e.currentTarget.setPointerCapture?.(e.pointerId)
                        setActiveControl(control)
                        sessionStorage.setItem('isClicked', true)
                        handleContinuousAction(ACTIONS[control])
                    }}
                    onPointerUp={() => {
                        setActiveControl(null)
                        sessionStorage.setItem('isClicked', false)
                        sendRa()
                    }}
                    onPointerCancel={() => {
                        setActiveControl(null)
                        sessionStorage.setItem('isClicked', false)
                        sendRa()
                    }}
                    onLostPointerCapture={() => {
                        setActiveControl(null)
                        sessionStorage.setItem('isClicked', false)
                        sendRa()
                    }}
                    onClick={(e) => e.preventDefault()}
                />
            ))}
        </div>
    )
}
export default Joystick
